
import { useCallback, useReducer } from 'react'

import { Model } from '../models/model'
import { payReducer } from '../reducers/payReducer'
// import { getTotalToPay } from '../helpers/compras'

const initialState = {
    detailPay: {
        id: 0,
        id_proveedor: 0,
        nombre_proveedor: '',
        fecha_pago: new Date(),
        id_tipo_pago: 0,
        id_cta_bancaria: 0,
        numero_operacion: '',
        total_pago: 0,
        id_compra: 0,
        id_moneda: 0,
        simbolo: "S/",
        separacion_miles: ",",
        separacion_decimales: ".",
        compra_total: 0,
        compra_total_pagado: 0,
        compra_total_por_pagar: 0,
        reading_mode: false,
        url_boucher: ''
    },
    pays: []
}

export const usePay = () => {

    const [state, dispatch] = useReducer(payReducer, initialState)
    const { pays, detailPay } = state

    const initCreateNewPay = async (dataCompra, itemsSelected = []) => {
        const payForItems = itemsSelected.length > 0

        let newItemsSelected = []
        let newTotalPorPagar = (payForItems ? 0 : dataCompra.total_por_pagar)

        if (payForItems) {

            for (let x = 0; x < itemsSelected.length; x++) {
                const item = itemsSelected[x]
                console.log({ item })

                // const newDataCalc = {
                //     impuesto_porcentaje: dataCompra.impuesto_porcentaje,
                //     impuesto_tipo_calculo: dataCompra.impuesto_tipo_calculo,
                //     subtotal: item.subtotal
                // }

                // const newTotalItem = await getTotalToPay(newDataCalc)

                const flowId = item?.flow_id || null
                newItemsSelected = [
                    ...newItemsSelected,
                    {
                        id_item_compra: item.id,
                        referencia: item.referencia,
                        monto: item.monto_a_pagar,
                        flow_id: flowId,
                        from: item.from
                    }
                ]

                newTotalPorPagar = newTotalPorPagar + item.monto_a_pagar

            }

        }

        const newPay = {
            ...detailPay,
            id:0,
            reconciled:false,
            reconciliation:null,
            id_proveedor: dataCompra.id_proveedor,
            nombre_proveedor: dataCompra.razon_social,
            fecha_pago: new Date(),
            // total_pago: dataCompra.total_por_pagar,
            total_pago: newTotalPorPagar,
            id_compra: dataCompra.id,
            id_moneda: dataCompra.id_moneda,
            simbolo: dataCompra.simbolo,
            separacion_miles: dataCompra.separacion_miles,
            separacion_decimales: dataCompra.separacion_decimales,
            compra_total: dataCompra.total_compra,
            compra_total_pagado: dataCompra.total_pagado,
            compra_total_por_pagar: dataCompra.total_por_pagar,
            pay_for_items: payForItems,
            items_to_pay: newItemsSelected
        }

        const action = {
            type: '[PAY] set detail',
            payload: newPay
        }

        dispatch(action)

    }

    const initGetAllPayByGasto = useCallback(async (compraId) => {

        const params = {
            url: `pagos/byGasto/${compraId}`
        }

        const resultDataList = await Model.getAll(params);

        const action = {
            type: '[PAY] Load list',
            payload: resultDataList
        }

        dispatch(action)
    }, [])

    const initGetOnePay = async (payId) => {

        const params = {
            url: `pagos/${payId}`
        }

        const dataOne = await Model.getOne(params)

        const action = {
            type: '[PAY] set detail',
            payload: dataOne
        }

        dispatch(action)

    }

    const initSavePay = async (newPay) => {

        const params = {
            url: 'pagos',
            dataForm: newPay
        }

        const resultId = await Model.save(params)

        const newDetail = {
            ...newPay,
            id: resultId
        }

        if (resultId) {

            const action = {
                type: '[PAY] set detail',
                payload: newDetail
            }

            dispatch(action)

        }

    }

    const initUpdatePay = async (dataPay) => {

        const params = {
            url: `pagos/${dataPay.id}`,
            dataForm: dataPay
        }

        const dataUpdate = await Model.update(params)

        const action = {
            type: '[PAY] set detail',
            payload: dataUpdate
        }

        dispatch(action)

    }

    const initDeletePay = async (payId) => {

        const params = {
            url: `pagos/${payId}`,
        }

        return await Model.delete(params)

    }

    return {
        pays,
        detailPay,

        initGetAllPayByGasto,
        initCreateNewPay,
        initGetOnePay,
        initSavePay,
        initUpdatePay,
        initDeletePay
    }

}
